import { render, staticRenderFns } from "./PaginatedTableContent.vue?vue&type=template&id=31754f12&scoped=true"
import script from "./PaginatedTableContent.vue?vue&type=script&lang=js"
export * from "./PaginatedTableContent.vue?vue&type=script&lang=js"
import style0 from "./PaginatedTableContent.vue?vue&type=style&index=0&id=31754f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31754f12",
  null
  
)

export default component.exports